import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'app/core/authentication/authentication.service';
import { PrivateService } from 'app/core/services/private.service';
import * as platform from 'platform';

@Component({
  selector: 'dialog-devices',
  templateUrl: './dialog-devices.component.html',
  styleUrls: ['./dialog-devices.component.scss']
})
export class DialogDevicesComponent implements OnInit {
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDevicesComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
              private privateService: PrivateService, private authService: AuthService) { }

  ngOnInit(): void {
    this.detectDeviceModel();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  detectDeviceModel() {
    // const userAgent = window.navigator.userAgent;
    // const info = platform.parse(userAgent);
    // this.deviceModel = info.description;
  }
  
  insertDevice() {
    this.isLoading = true;
    console.log(this.data.value,this.data.deviceName)
    this.privateService.insertDevice(this.data.value, this.data.deviceName, this.data.pass).subscribe((response)=>{
      this.authService.login(this.data.value, this.data.pass, '/home');
      this.dialogRef.close();
    },(error) => {
      console.log("An Error Occured");
      this.dialogRef.close();
      this.isLoading = false;
    })
  }
}
